/**
 * Palmistry 101 — access helpers (single source of truth).
 * Replace `hasPalmistryAccess` later with Supabase/metadata when auth is wired.
 */

export const STORAGE_ACCESS_KEY = 'amm_palmistry101_access';

export function isPalmistryDevUnlockEnabled() {
  return process.env.REACT_APP_PALMISTRY101_DEV_UNLOCK === 'true';
}

/**
 * @returns {boolean} Whether the visitor has purchased / unlocked the full course.
 */
export function hasPalmistryAccess() {
  if (isPalmistryDevUnlockEnabled()) return true;
  try {
    return localStorage.getItem(STORAGE_ACCESS_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Persist full access (e.g. after successful checkout redirect handler).
 */
export function grantPalmistryAccess() {
  try {
    localStorage.setItem(STORAGE_ACCESS_KEY, '1');
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('Palmistry 101: could not write access to localStorage', e);
    }
  }
}

/**
 * Post-checkout / email-link convenience: grant access when URL includes a known flag, then clean the URL.
 *
 * Supported (any one):
 *   ?palmistry=1
 *   ?access=granted
 *
 * Safe: only sets localStorage and uses replaceState (no extra history entry).
 * Configure your payment platform thank-you URL to include one of these query params.
 *
 * @returns {boolean} true if access was granted from the URL this call
 */
export function applyPalmistryAccessFromUrl() {
  if (typeof window === 'undefined') return false;
  const params = new URLSearchParams(window.location.search);
  const grant =
    params.get('palmistry') === '1' || params.get('access') === 'granted';
  if (!grant) return false;
  grantPalmistryAccess();
  const path = window.location.pathname + window.location.hash;
  window.history.replaceState({}, document.title, path);
  return true;
}
